// export const tinyMceEditorId = 'tinyMceEditorId';

export const tinyMceEditorImgFileIdDataAttribute = 'data-fileId';
export const tinyMceEditorImgBase64PrefixDataAttribute = 'data-base64Prefix';

export const tinyMceKey = window.config?.REACT_APP_TINY_EDITOR_KEY || '';

export const defaultMaxImageSize = 300;